import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { isMobile } from "./style";

const Footer: React.FC = () => {
  const NavHandler = () => {
    if (window.location.pathname === "/") {
      window.location.replace("/");
    }
  };

  return (
    <Footers>
      <>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to=""
          onClick={NavHandler}
        >
          랜덤 추천
        </NavLinks>
      </>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/dev"
        >
          개발자
        </NavLinks>
      </Nav>
    </Footers>
  );
};

export default Footer;

const Footers = styled.div`
  background: #f2ead3;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 95px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${isMobile} {
    height: 70px;
  }
`;

const Nav = styled.div`
  border-right: 1px solid rgba(223, 215, 191, 0.8);
`;

const NavLinks = styled(NavLink)`
  color: #dfd7bf;
  font-family: "GmarketSansBold";
  font-size: 23px;
  font-weight: 700;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &:hover {
    color: #bbb296;
  }

  &.active {
    color: #bbb296;
  }

  ${isMobile} {
    font-size: 18px;
  }
`;
